export default {
    formIncorporationConsumptionLoading: false,
    formIncorporationConsumption: {
        account_id: null,
        year_month: null,
        file: null
    },
    formIncorporationUsersConsumption: {
        file: null
    },
    formBankConciliation: {
        account_id: null,
        year_month: null,
        state: null
    },
    accounts: [],
    formIncorporationConsumptionResponse: {},
    dataBankConciliation: {
        bankConcilOper: [],
        documentTransactions: []
    },
    dataBankConciliationLoading: false,
    bankConciliationOperTransactions: {
        informationExtract: [],
        accountingInformation: []
    },
    bankConciliationTransactionsDetail: false,
    bankConciliationStatus: null,
    documentsByUserIdLoading: false,
    documents: [],
    reportConsumptionForm: {
        date: null
    },
    subscriber: null,
    contacts: [],
    selectedContact: {
        customer: {
            credit_quota: 0
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/incorporation-consumption/state.js